module.exports = __webpack_public_path__ + "static/media/safeTravels.e3f8f508.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/footer/safeTravels.png
// module id = 248
// module chunks = 0